import {
    faArrowRightFromBracket,
    faCalendarDays,
    faCreditCard,
    faPalette,
    faFileInvoiceDollar,
    faGear,
    faUserAlt,
    faUsers,
    faLayerGroup,
    faShapes,
    faPercent,
    faChartLine,
    faFileLines,
    faCartShopping,
    faCheckToSlot,
    faCalendarWeek,
    faHouse,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Container, Image, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { postMethod } from "../../requests";
import { BasicContext } from "../../App";
import $ from "jquery";
import { faCalendarPlus } from "@fortawesome/free-regular-svg-icons";

const BackOfficeNavbar = () => {
    const { t } = useTranslation();
    const { checkServerData, setLoading, setShowLogoutModal, changeView, showView } = useContext(BasicContext);
    const [navs, setNavs] = useState(null);
    const [options, setOptions] = useState(null);

    const checkOptionsVisibility = async () => {
        const res = await postMethod("/admin-navbar-options", {
            options: [
                "SCHEDULE_VIEW",
                "SCHEDULE_ADMIN_VIEW",
                "USERS_VIEW",
                "TRANSACTIONS_VIEW",
                "TEMPLATES_VIEW",
                "PASSES_LIST_VIEW",
                "DISCOUNT_CODES",
                "REPORTS",
                "GENERAL_SETTINGS",
                "USER_LOGS",
                "RESERVATIONS_VIEW",
            ],
        });
        if (checkServerData(res)) {
            setOptions(res.data.list);
        }
    };

    useEffect(() => {
        if (options) {
            const schedulePos = [
                {
                    icon: faCalendarDays,
                    name: t("schedule.displaySchedule"),
                    action: () => changeView({ nav: "schedule", sub: "main", params: { moduleName: "ADMIN_APP" } }),
                },
                {
                    icon: faCalendarPlus,
                    name: t("schedule.createNewClass"),
                    action: () => changeView({ nav: "classes", sub: "creatingClass" }),
                },
                {
                    icon: faCheckToSlot,
                    name: t("reservations.reservationsList"),
                    action: () => changeView({ nav: "reservations", sub: "reservationsList", params: { moduleName: "ADMIN_APP" } }),
                },
                {
                    icon: faCalendarWeek,
                    name: t("classes.historyClassesList"),
                    action: () => changeView({ nav: "classes", sub: "historyClasses" }),
                },
            ];
            const passesPos = [
                {
                    icon: faCartShopping,
                    name: t("passes.studentsPasses"),
                    action: () => changeView({ nav: "passes", sub: "studentsPasses" }),
                },
                {
                    icon: faCreditCard,
                    name: t("passes.passesList"),
                    action: () => changeView({ nav: "passes", sub: "passesList" }),
                },
            ];
            const templatesPos = [
                {
                    icon: faPalette,
                    name: t("templates.classesTemplates"),
                    action: () => changeView({ nav: "templates", sub: "classesTemplates" }),
                },
                {
                    icon: faLayerGroup,
                    name: t("classes.classesLevels"),
                    action: () => changeView({ nav: "templates", sub: "classesLevels" }),
                },
                {
                    icon: faShapes,
                    name: t("classes.classesCategories"),
                    action: () => changeView({ nav: "templates", sub: "classesCategories" }),
                },
                {
                    icon: faHouse,
                    name: t("frontPage.title"),
                    action: () => changeView({ nav: "templates", sub: "frontPage" }),
                },
            ];

            const menuPos = [
                {
                    icon: faFileInvoiceDollar,
                    name: t("transactions.list"),
                    show: options.filter((e) => e.option === "TRANSACTIONS_VIEW" && e.value).length > 0 ? true : false,
                    action: () => changeView({ nav: "transactions", sub: "transactionsList" }),
                },
                {
                    icon: faPercent,
                    name: t("codes.discountCodes"),
                    show: options.filter((e) => e.option === "DISCOUNT_CODES" && e.value).length > 0 ? true : false,
                    action: () => changeView({ nav: "codes", sub: "discountCodesList" }),
                },
                {
                    icon: faChartLine,
                    name: t("reports.reports"),
                    show: options.filter((e) => e.option === "REPORTS" && e.value).length > 0 ? true : false,
                    action: () => changeView({ nav: "reports" }),
                },
                {
                    icon: faGear,
                    name: t("settings.settings"),
                    show: options.filter((e) => e.option === "GENERAL_SETTINGS" && e.value).length > 0 ? true : false,
                    action: () => changeView({ nav: "settings" }),
                },
                {
                    icon: faFileLines,
                    name: t("userLogs.logs"),
                    show: options.filter((e) => e.option === "USER_LOGS" && e.value).length > 0 ? true : false,
                    action: () => changeView({ nav: "userLogs" }),
                },
                { icon: null },
                { icon: faUserAlt, name: t("profile"), show: true, action: () => changeView({ nav: "userProfile" }) },
                { icon: faArrowRightFromBracket, name: t("logout"), show: true, action: () => setShowLogoutModal(true) },
            ];

            setNavs({
                schedulePos: schedulePos,
                passesPos: passesPos,
                templatesPos: templatesPos,
                menuPos: menuPos,
            });
        }
        // eslint-disable-next-line
    }, [options]);

    useEffect(() => {
        if (navs) {
            setLoading(false);
        }
        // eslint-disable-next-line
    }, [navs]);

    useEffect(() => {
        checkOptionsVisibility();
        // eslint-disable-next-line
    }, []);

    const handleCloseNav = () => {
        if ($(".navbar-collapse").hasClass("show")) {
            const toggleButton = document.querySelector(".navbar-toggler");
            if (toggleButton) {
                toggleButton.click(); // Wywołuje kliknięcie w Navbar.Toggle
            }
        }
        scrollToTop();
    };

    const scrollToTop = () => {
        if (showView.nav === "users" && showView.sub === "userDetails") window.scrollTo(0, 0);
    };

    return (
        <Fragment>
            {navs && (
                <Navbar expand="xxl" sticky="top" id="backOfficeNavbar" className="office-navbar">
                    <Container>
                        <Navbar.Brand>
                            <Image src="/images/pt_logo.svg" alt="pole therapy logo" className="logo-navbar" />
                        </Navbar.Brand>
                        {options.filter((e) => e.option === "SCHEDULE_ADMIN_VIEW" && e.value).length > 0 && navs.schedulePos ? (
                            <NavDropdown
                                align="start"
                                title={
                                    <>
                                        <FontAwesomeIcon icon={faCalendarDays} className="me-lg-2" />
                                        <span className="d-none d-lg-inline">{t("schedule.schedule")}</span>
                                    </>
                                }
                                id="schedule-nav-dropdown"
                                onClick={() => handleCloseNav()}
                            >
                                {navs.schedulePos.map((e, i) => (
                                    <Fragment key={i}>
                                        <NavDropdown.Item
                                            as={Button}
                                            className="me-lg-2 me-xl-3"
                                            onClick={() => {
                                                e.action();
                                                handleCloseNav();
                                            }}
                                        >
                                            <FontAwesomeIcon icon={e.icon} className="me-2" />
                                            {e.name}
                                        </NavDropdown.Item>
                                    </Fragment>
                                ))}
                            </NavDropdown>
                        ) : (
                            options.filter((e) => e.option === "SCHEDULE_VIEW" && e.value).length > 0 && (
                                <Nav.Link
                                    as={Button}
                                    onClick={() => {
                                        changeView({ nav: "schedule", sub: "main", params: { moduleName: "ADMIN_APP" } });
                                        handleCloseNav();
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCalendarDays} className="me-2" />
                                    <span /* className="d-none d-lg-inline" */>{t("schedule.schedule")}</span>
                                </Nav.Link>
                            )
                        )}

                        {options.filter((e) => e.option === "USERS_VIEW" && e.value).length > 0 && (
                            <Nav.Link
                                as={Button}
                                onClick={() => {
                                    changeView({ nav: "users", sub: "usersList" });
                                    handleCloseNav();
                                }}
                            >
                                <FontAwesomeIcon icon={faUsers} className="me-lg-2" />
                                <span className="d-none d-lg-inline">{t("users.users")}</span>
                            </Nav.Link>
                        )}
                        {options.filter((e) => e.option === "PASSES_LIST_VIEW" && e.value).length > 0 && navs.passesPos && (
                            <NavDropdown
                                align="end"
                                title={
                                    <>
                                        <FontAwesomeIcon icon={faCreditCard} className="me-lg-2" />
                                        <span className="d-none d-lg-inline">{t("passes.passes")}</span>
                                    </>
                                }
                                id="passes-nav-dropdown"
                                onClick={() => handleCloseNav()}
                            >
                                {navs.passesPos.map((e, i) => (
                                    <Fragment key={i}>
                                        <NavDropdown.Item
                                            as={Button}
                                            className="me-lg-2 me-xl-3"
                                            onClick={() => {
                                                e.action();
                                                handleCloseNav();
                                            }}
                                        >
                                            <FontAwesomeIcon icon={e.icon} className="me-2" />
                                            {e.name}
                                        </NavDropdown.Item>
                                    </Fragment>
                                ))}
                            </NavDropdown>
                        )}
                        {options.filter((e) => e.option === "TEMPLATES_VIEW" && e.value).length > 0 && navs.templatesPos && (
                            <NavDropdown
                                align="end"
                                title={
                                    <>
                                        <FontAwesomeIcon icon={faPalette} className="me-lg-2" />
                                        <span className="d-none d-lg-inline">{t("templates.templates")}</span>
                                    </>
                                }
                                id="templates-nav-dropdown"
                                onClick={() => handleCloseNav()}
                            >
                                {navs.templatesPos.map((e, i) => (
                                    <Fragment key={i}>
                                        <NavDropdown.Item
                                            as={Button}
                                            className="me-lg-2 me-xl-3"
                                            onClick={() => {
                                                e.action();
                                                handleCloseNav();
                                            }}
                                        >
                                            <FontAwesomeIcon icon={e.icon} className="me-2" />
                                            {e.name}
                                        </NavDropdown.Item>
                                    </Fragment>
                                ))}
                            </NavDropdown>
                        )}
                        <Navbar.Toggle aria-controls="basicNavBar" />
                        <Navbar.Collapse id="basicNavBar">
                            <Nav className="me-auto"></Nav>
                            <Nav>
                                {navs.menuPos.map((e, i) => (
                                    <Fragment key={i}>
                                        {e.show && (
                                            <>
                                                {!e.icon ? (
                                                    <hr className="d-xxl-none" />
                                                ) : (
                                                    <Nav.Link
                                                        as={Button}
                                                        variant="link"
                                                        onClick={() => {
                                                            e.action();
                                                            handleCloseNav();
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={e.icon} className="me-2" />
                                                        <span>{e.name}</span>
                                                    </Nav.Link>
                                                )}
                                            </>
                                        )}
                                    </Fragment>
                                ))}
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            )}
        </Fragment>
    );
};

export default BackOfficeNavbar;
